// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"618c3fde","432":"6411a477","453":"1407b060","798":"90839ed7"}[chunkId] + ".chunk.js";
};